//  @flow
import type { ServicePackageData, ServicePackageName } from "booking/services/servicePackages/types"

export const servicePackageTranslationKeys = {
  Basic: "booking.summary.service_package.basic",
  Plus: "booking.summary.service_package.plus",
  Premium: "booking.summary.service_package.premium",
}
const cartTranslationKeyServicePackage = {
  Basic: __("booking.summary.service_package.basic"),
  Plus: __("booking.summary.service_package.plus"),
  Premium: __("booking.summary.service_package.premium"),
}
const servicePackagePrice = (sp: ?ServicePackageData) => (sp && sp.price.amount) || 0

const getServicePackage = (
  sp: ServicePackageName,
  all: $ReadOnlyArray<ServicePackageData>,
): ?ServicePackageData => all.find(s => s.packageType === sp)

const getServicePackagePrice = (
  sp: ServicePackageName,
  all: $ReadOnlyArray<ServicePackageData>,
): number => servicePackagePrice(getServicePackage(sp, all))

export {
  getServicePackage,
  cartTranslationKeyServicePackage,
  servicePackagePrice,
  getServicePackagePrice,
} // eslint-disable-line import/prefer-default-export
